import React from 'react';
import styled from 'styled-components';
import { fonts, colors } from '../common/mixins.js';
import Icon from '../common/Icon.jsx';
import { formatDate } from '../common/helpers.js';

const Container = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items:flex-start;
  padding:16px;
  border-radius:8px;
  background-color:${colors.warningAlert};
`;

const Text = styled.div`
  ${fonts.normalTextSmall()}; 
`;

const Bold = styled.div`
  font-weight:600; 
  display:inline;
`;

const IconContainer = styled.div`
flex-shrink:0;
`;

const ReservationAlert = ({ expirationDate, culture, reservationExpired }) => {
   
    const formattedDateTime = formatDate({ date: expirationDate, culture });

    const setText = (reservationExpired) => {
        if (reservationExpired) {
            return <Text>{orderdetails_resources.ReservationExpired}
                {' '}<Bold>{formattedDateTime}</Bold>.
            </Text>;        
        }
        return <Text>{orderdetails_resources.ReservationValidUntil}
            {' '}<Bold>{formattedDateTime}</Bold>
            {orderdetails_resources.SeatNotGuaranteed}
        </Text>;
    }
    return (
        <Container>
            <IconContainer><Icon kind="warning-colored" /></IconContainer>
            {setText(reservationExpired)}
        </Container>
    );
};

export default ReservationAlert;
